export default {
  selectedTechnician: {},
  selectedTechBusiness: {},
  techBusiness: {},
  techBusinesses: []
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/state.js